import * as Common from '@/tenant/common';

export class ECSetting extends Common.StateObject {
  constructor(){
    super('ECSetting');
    this.workflowCode="approval";
    this.workflowStateId = Common.ApprovalStatus.NotApproved;//フラグ値を変更;           
  }

  public ecFlag: ECFlags = ECFlags.None ;
  public storeCode: string = '';
  public seqNo: number = 0;
  public ecOptionFlag: ECOptionFlags = ECOptionFlags.None;
  public segmentId: number;
  public segment: Common.Segment;
  public customerId: number;
  public customer : Common.Counterpart;
  public warehouseId: number;
  public warehouse : Common.Counterpart;
  public bankAccountCode: string;
  public bankAccount: Common.BankAccount;
  public orderWorkflowId:number = 0;
  public deliveryWorkflowId:number = 0;
  public purchaseDeliveryWorkflowId:number = null;
  public stockRelocationWorkflowId:number = null;
  public invoiceWorkflowId:number =0;  
  public masterWorkflowId:number = 0;
  public commodityId: number;    
  public commodity: Common.Commodity;
  public defaultUOM:string;
  public taxCode:string='';
  public reducedTaxCode:string='';  
  public exemptTaxCode:string=null;  
  public token:string = '';
  public hasValidToken:boolean = false;
  public autoCommodityInsert:boolean = true;
  public isUseFBA:boolean = false;
  public yahooPublicKey: string = "";
  public yahooPublicKeyVersion: number = 0;
  // Amazon用項目（プライベートアプリ対応）
  public clientId: string = '';
  public clientSecret: string = '';
  
  public get autoCommodityInsert2():boolean {
    return this.autoCommodityInsert;
  }
  public set autoCommodityInsert2(value:boolean) {
    this.autoCommodityInsert = value;
    if (value == false) this.defaultUOM = null;
  }  
  public orderSyncStartDate : Date = new Date().getCalendarDate();

  public get messageOnEdit():string { 
    return '「公開取消」をクリックして状態を「公開待ち」に戻してから編集してください。';  
  }    
  public get messageOnDelete():string {
    return '「公開取消」をクリックして状態を「公開待ち」に戻してから削除してください。';
  }
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>公開中
    if (actionFlag == Common.DefaultActionFlags.edit && stateId ==  Common.ApprovalStatus.Approved)
      return Common.ApprovalStatus.NotApproved;
    //削除=>なし
    //更新=>未確定・編集中
    else if (actionFlag == Common.DefaultActionFlags.update &&  stateId ==  Common.ApprovalStatus.NotApproved)
      return Common.ApprovalStatus.Approved;
    else if (actionFlag == Common.DefaultActionFlags.add && stateId == Common.ApprovalStatus.NotApproved)
      return Common.ApprovalStatus.Approved;        
    else
      return 0;
  }  
}

export enum ECFlags 
{
    None =0,
    Base = 1,
    Shopify = 2,
    Amazon = 4,
    Rakuten = 8,
    Smaregi = 16,
    Bcart = 32,
    BcartOrder = 33,
    Yahoo = 64,

    WMS = 128,
    Logiless = WMS + 1,
}
export enum ECOptionFlags 
{
    None =0,
    Base_UseIdentifier = 1,
}

export class ECSettingQuery extends Common.LoadQuery {
  constructor(){
    super('ECSettingQuery',ECSetting);
    this.sort = 'ecFlag';
  }
  public state: Common.ApprovalStatus = null;
}


export class ECApiAuthorizeQuery extends Common.Query {
  constructor(authCode:string, ecFlag:Common.ECFlags, seqNo:number, codeVerifier:string = null, contractId:string = null){
    super('ECApiAuthorizeQuery',new Common.ModelBinder(ECSetting));
    this.authCode = authCode;
    this.ecFlag = ecFlag;
    this.seqNo = seqNo;
    this.codeVerifier = codeVerifier; 
    this.contractId = contractId;
  }
    public authCode : string;              
    public requestHash :string;
    public ecFlag : Common.ECFlags = Common.ECFlags.None;
    public seqNo : number = 0;
    public codeVerifier : string;
    public contractId: string;
}

export class ECCommodityQuery extends Common.Query {
  constructor(settings: ECSetting[] = null){
    super('ECCommodityQuery',null);
    this.settings = settings;
  }
    public settings: ECSetting[];              
    public isAsync:boolean = true;
}
export class ECOrderQuery extends Common.Query {
  constructor(settings: ECSetting[] = null){
    super('ECOrderQuery',null);
    this.settings = settings;
  }
    public settings: ECSetting[];          
    public isAsync:boolean = true;        
}
export class ECProcessQuery extends Common.Query {
  constructor(settings: ECSetting[] = null){
    super('ECApiProcessQuery',null);
    this.settings = settings;
  }
    public settings: ECSetting[];              
    public isAsync:boolean = true;    
}
export class GetBaseClientIdQuery extends Common.Query {
  constructor(){
    super('GetBaseClientIdQuery', null);
  }
}
export class GetSmaregiClientIdQuery extends Common.Query {
  constructor(){
    super('GetSmaregiClientIdQuery', null);
  }
}
export class GetBcartClientIdQuery extends Common.Query {
  constructor(){
    super('GetBcartClientIdQuery', null);
  }
}

export class GetYahooClientIdQuery extends Common.Query {
  constructor(){
    super('GetYahooClientIdQuery', null);
  }
}

export class GetAmazonClientIdQuery extends Common.Query {
  constructor(){
    super('GetAmazonClientIdQuery', null);
  }
}

export class GetAmazonApplicationIdQuery extends Common.Query {
  constructor(){
    super('GetAmazonApplicationIdQuery', null);
  }
}

export class GetLogilessClientIdQuery extends Common.Query {
  constructor(){
    super('GetLogilessClientIdQuery', null);
  }
}